import CompetencyCourse from "@/components/training/CompetencyCourse";
import { ricePrioritiesCourse } from "@/data/longhandCompetencyCourses";

const AIPriorities = () => <CompetencyCourse course={ricePrioritiesCourse} />;

export default AIPriorities;
